import { faArrowLeft, faCheck, faRotateLeft, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import VoxelIconButton from '../../../../../components/voxel/Buttons/VoxelIconButton';
import VoxelSelect from '../../../../../components/voxel/Forms/VoxelSelect';
import { ContentActionGq } from '../../../../../graphql/projects/models/ContentActionGq';
import { ContentTaskGq } from '../../../../../graphql/projects/models/ContentTaskGq';
import { projectsApiService } from '../../../../../graphql/projects/projectsApiService';

export interface ContentTaskActionInputProps {
  reload: () => Promise<unknown>;
  contentTask: ContentTaskGq;
  originalValue?: ContentActionGq;
  newValue?: ContentActionGq;
  changed: boolean;
  setUpdating: Dispatch<SetStateAction<boolean>>;
  updating: boolean;
}

export const ContentTaskActionInput: React.FC<ContentTaskActionInputProps> = ({
  reload,
  contentTask,
  updating,
  setUpdating,
  originalValue,
  changed,
  newValue,
}) => {
  // Form logic
  const initialValue = newValue ?? originalValue ?? ContentActionGq.OK;
  const [selectOpen, setSelectOpen] = useState(true);
  const [state, setState] = useState<ContentActionGq>(initialValue);

  useEffect(() => {
    setState(initialValue);
  }, [initialValue]);

  const handleCancel = () => {
    setState(initialValue);
  };

  const mutation = projectsApiService.mutations.contentPlan.useUpdateTaskDetails();
  const handleSubmit = () => {
    setUpdating(true);

    // Same old value
    if (state === originalValue && !newValue) {
      setUpdating(false);
      return;
    }

    mutation({ taskId: contentTask.id, actionNew: state, projectId: contentTask.projectId })
      .then(reload)
      .finally(() => setUpdating(false));
  };

  return (
    <div className="flex flex-row items-center flex-nowrap gap-2">
      <VoxelSelect
        size="sm"
        inputWidthClass="w-40"
        outlined={state === initialValue ? false : true}
        autoFocus={true}
        disabled={updating}
        selectedOptionValue={state}
        setSelectedOption={(option) => setState(option.value as ContentActionGq)}
        options={[
          { value: ContentActionGq.CREATE, title: 'CREATE' },
          { value: ContentActionGq.OK, title: 'OK' },
          { value: ContentActionGq.OPTIMIZE, title: 'OPTIMIZE' },
        ]}
      />
      {state !== initialValue && (
        <VoxelIconButton
          disabled={updating}
          tooltip={'Revert change'}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            handleCancel();
          }}
          size={'xs'}
          color={'light-gray'}
          icon={<FontAwesomeIcon icon={faRotateLeft} />}
        />
      )}
      {state !== initialValue && (
        <VoxelIconButton
          type={'submit'}
          tooltip={'Submit change'}
          disabled={updating}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            handleSubmit();
          }}
          size={'xs'}
          color={'success'}
          icon={<FontAwesomeIcon icon={faCheck} size="lg" />}
        />
      )}
    </div>
  );
};

export default ContentTaskActionInput;
